module.exports = __webpack_public_path__ + "img/bjpay.dc82639d.png";